import React, { useState } from 'react';

// Material UI
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import { DialogActions } from '@mui/material';

// Components
import Modal from '../../../../components/modal/index';
import SellerAutocomplete from '../../../../components/sellerAutocomplete';
import useCart from '../../../../hooks/orders/CartProvider';

const SellerModal = ({ onClose, open }) => {
    const { sale: { sellerCode, seller }, update } = useCart();
    const [sellerSelected, setSellerSelected] = useState(seller);
    
    const handleSave = () => {
        if (sellerSelected.code !== sellerCode) {
            update({ sellerCode: sellerSelected.code });
        }

        onClose();
    }

    const onChange = (value) => {
        setSellerSelected(value);
    }

    return (
        <Modal
            open={open}
            onClose={onClose}
            title='Vendedor'
            contentProps={{ dividers: true }}
            customButtons={() =>
                <DialogActions>
                    <Button
                        onClick={onClose}
                        color="primary"
                    >
                        Cancelar
                    </Button>
                    <Button
                        onClick={handleSave}
                        color="primary"
                        variant='contained'
                    >
                        Guardar
                    </Button>
                </DialogActions>
            }
        >
            <Grid container spacing={2}>
                <Grid size={12}>
                    <SellerAutocomplete
                        onChange={onChange}
                        value={sellerSelected}
                    />
                </Grid>
            </Grid>
        </Modal>
    );
}
export default SellerModal;